import axios, { AxiosInstance } from 'axios'
import { getConfig } from '../config/Constants'
import type { ApiResponse } from '../types/api.types'

let apiInstance: AxiosInstance | null = null

function getApiInstance() {
    if (!apiInstance) {
        const config = getConfig()
        apiInstance = axios.create({
            baseURL: `${config.apiUrl}`,
            headers: {
                'Content-Type': 'application/json',
            },
        })

        // Add request interceptor to add auth token
        apiInstance.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem('access_token')
                if (token && token !== 'undefined' && token !== 'null') {
                    config.headers.Authorization = `Bearer ${token}`
                }
                return config
            },
            (error) => {
                return Promise.reject(error)
            }
        )

        // Add response interceptor to handle 401 errors
        apiInstance.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response?.status === 401) {
                    localStorage.removeItem('access_token')
                    localStorage.removeItem('user')
                    window.location.href = '/sign-in'
                }
                return Promise.reject(error)
            }
        )
    }
    return apiInstance
}

export interface BillingHistoryItem {
    id: string
    product_id: string
    product_type: 'course' | 'bundle' | 'digital_product'
    product_title: string
    purchase_price: number
    currency: string
    enrolled_at: string
    status: string
    stripe_payment_intent_id: string
}

export const billingService = {
    getBillingHistory
}

/**
 * Get billing/purchase history
 */
async function getBillingHistory(): Promise<ApiResponse<BillingHistoryItem[]>> {
    try {
        const response = await getApiInstance().get('/enrollments/my-billing-history')
        return {
            success: true,
            data: response.data.data
        }
    } catch (error: any) {
        console.error('Get billing history error:', error)
        return {
            success: false,
            error: error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to get billing history'
        }
    }
}
